import './PopupError.scss'

interface PopupErrorProps {
  errorMessage: string
  setErrorMessage: React.Dispatch<React.SetStateAction<string>>
}

function PopupError({ errorMessage, setErrorMessage }: PopupErrorProps) {
  if (!errorMessage) return null
  return (
    <div className="pop-up-error">
      <span>{errorMessage}</span>
      <button
        className="pop-up-error-close"
        onClick={() => setErrorMessage('')}
        aria-label="Close error message"
      >
        ×
      </button>
    </div>
  )
}

export default PopupError
